import { render, staticRenderFns } from "./IconDocumentRemoveOutline.vue?vue&type=template&id=46cebbe6"
import script from "./IconDocumentRemoveOutline.vue?vue&type=script&lang=js"
export * from "./IconDocumentRemoveOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports